export default __webpack_public_path__ + "icon-strongher.297edcab.png";